import { ColumnType } from "antd/lib/table";
import { FaEdit } from "react-icons/fa";
import { MdCheck } from "react-icons/md";
import { ButtonIconApprove, ButtonIconEdit, ButtonIconView, ContainerButtons } from "./styles";
import { IoMdEye } from "react-icons/io";
import { formatarDataBR } from "../ModalPlanejamentoOperacoes/ModalAnteciparOuProrrogar/utils";
import { TalhaoJustificados } from "../../interfaces/Talhao";
import { limitarCaracteres } from "../ModalPlanejamentoOperacoes/utils";
import { Tooltip } from "antd";
import { Status } from "./partials/Status";
import { showConfirm } from "infra/helpers/alerta";

const columns = (
  setTalhaoJustificado: (talhaoJustificado: TalhaoJustificados) => void,
  setIsOpenView: (isOpenView: boolean) => void,
  setIsOpenEdit: (isOpenEdit: boolean) => void,
  groupByOption: string,
  setId: (id: string) => void,
  ids: Set<string>,
  setIds: (updater: Set<string> | ((prev: Set<string>) => Set<string>)) => void,
  data: TalhaoJustificados[],
  allChecked: boolean,
  handleApprove: (str?: string) => void,
  tipoJustificativa: number,
): ColumnType<any>[] => {
  const TOTAL_COLUMNS = 13;

  let columnsShow: ColumnType<any>[] = [
    {
      title: (
        <input
          type="checkbox"
          checked={allChecked}
          onChange={(e) => {
            const checked = e.target.checked;

            if (checked) {
              setIds((prev) => {
                const next = new Set(prev);

                data.forEach((item) => {
                  next.add(item.planoOperacionalOperacaoTalhaoId);
                });

                return next;
              });
            } else {
              setIds((prev) => {
                const next = new Set(prev);

                data.forEach((item) => {
                  next.delete(item.planoOperacionalOperacaoTalhaoId);
                });

                return next;
              });
            }
          }}
        />
      ),
      dataIndex: "status",
      align: "center",
      width: 10,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: TOTAL_COLUMNS };
        }
        return {};
      },
      render: (_, record: any) => {
        if (record.type === 'group') {
          return (
            <strong style={{ fontSize: 14 }}>
              {record.label} ({record.count})
            </strong>
          );
        }
        return (
          <input
            type="checkbox"
            checked={ids.has(record.planoOperacionalOperacaoTalhaoId)}
            onChange={(e) =>
              setIds((prev) => {
                const next = new Set(prev);

                if (e.target.checked) {
                  next.add(record.planoOperacionalOperacaoTalhaoId);
                } else {
                  next.delete(record.planoOperacionalOperacaoTalhaoId);
                }

                return next;
              })
            }
          />
        );
      },
    },

    {
      title: "Período de Produção",
      dataIndex: "safraPeriodo",
      align: "center",
      width: 35,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) => <span style={{ fontSize: 13 }}>{value}</span>,
    },
    {
      title: "Talhão",
      dataIndex: "talhao",
      align: "center",
      width: 18,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) => {
        return (
          <span style={{ fontSize: 13 }}>
            {value}
          </span>
        )
      },
    },
    {
      title: "Área (ha)",
      dataIndex: "talhaoArea",
      align: "center",
      width: 22,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: number) => <span style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Classe de Operações",
      dataIndex: "operacaoClasse",
      align: "center",
      width: 30,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) => <span style={{ fontSize: 13 }}>{value ?? "-"}</span>,
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      width: 40,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) => <span style={{ fontSize: 13 }}><Tooltip title={value} placement="top">{limitarCaracteres(value, 25) ?? "-"}</Tooltip></span>,
    },
    {
      title: "Data Programada",
      dataIndex: "dataProgramada",
      align: "center",
      width: 30,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) => <span style={{ fontSize: 13 }}>{formatarDataBR(value) ?? "-"}</span>,
    },
    {
      title: tipoJustificativa === 1 ? "Dias em Atraso" : "Ação",
      dataIndex: tipoJustificativa === 1 ? "diasEmAtraso" : "acao",
      align: "center",
      width: 35,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) =>
        <span>{value}</span>
    },
    {
      title: "Data da Justificativa",
      dataIndex: "justificativaAtrasoDataAtualizacao",
      align: "center",
      width: 33,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) =>
        <span style={{ fontSize: 13 }}>{formatarDataBR(value) ?? "-"}</span>
    },
    {
      title: "Motivo",
      dataIndex: "justificativaAtrasoMotivo",
      align: "center",
      width: 35,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) =>
        <span>{value}</span>
    },
    {
      title: "Justificativa",
      dataIndex: "justificativaAtrasoObservacao",
      align: "center",
      width: 30,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (value: string) =>
        <Tooltip title={value} placement="top">
          <span>{limitarCaracteres(value, 50)}</span>
        </Tooltip>
    },
    {
      title: "Status da Aprovação",
      dataIndex: "status",
      align: "center",
      width: 30,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (status: string) =>
        <Status title={status} />
    },
    {
      title: "Ações",
      dataIndex: "planoOperacionalOperacaoTalhaoId",
      align: "center",
      width: 30,
      onCell: (record: any) => {
        if (record.type === 'group') {
          return { colSpan: 0 };
        }
        return {};
      },
      render: (id: string, dataValue: TalhaoJustificados) => (
        <ContainerButtons>
          <ButtonIconView onClick={() => {
            setTalhaoJustificado(dataValue);
            setIsOpenView(true);
          }}>
            <IoMdEye />
          </ButtonIconView>
          <Tooltip title={dataValue?.blocked ? "Você não tem permissão para editar justificativa" : undefined}>
            <span style={{ display: "inline-block" }}>
              <ButtonIconEdit
                disabled={dataValue?.blocked}
                onClick={() => {
                  setTalhaoJustificado(dataValue);
                  setId(id);
                  setIsOpenEdit(true);
                }}>
                <FaEdit />
              </ButtonIconEdit>
            </span>
          </Tooltip>
          <Tooltip title={dataValue?.blocked ? "Você não tem permissão para aprovar justificativa" : undefined}>
            <span style={{ display: "inline-block" }}>
              <ButtonIconApprove
                disabled={dataValue?.blocked}
                onClick={async () => {
                  const { isConfirmed } = await showConfirm("Tem certeza que deseja aprovar essa justificativa?");
                  if (!isConfirmed) {
                    return;
                  }
                  handleApprove(id);
                }}>
                <MdCheck />
              </ButtonIconApprove>
            </span>
          </Tooltip>
        </ContainerButtons>
      )
    },
  ];

  return columnsShow;
}
export default columns;
